import { DirectivoAprobadorObtenerVistaPreviaFormularioReintegroVacaciones } from "components/DirectivoUnidad/AprobacionSolicitudes/FunctionsAprobacionSolicitudes";
import { PersonalAprobarAccion, PersonalAprobarState } from "./PersonalAprobar";




export function reducer(state: PersonalAprobarState, action: PersonalAprobarAccion): PersonalAprobarState {

    const copiaState = { ...state };

    switch (action.type) {
        case "OBTENER_INFORMACION":
            return {
                ...state,
                loadingInfo: true,
                
            }


        case "INFORMACION_CARGADA":
            if (action.payload) {
                return {
                    ...state,
                    listadoPersonal:action.payload.listadoPersonal,
                    mesActual:action.payload.mesActual,
                    anioActual:action.payload.anioActual,
                    fechaActual:action.payload.fechaActual,
                    loadingInfo: false
                }
            }
            else {
                return {
                    ...state,
                    listadoPersonal: [],
                    loadingInfo: false
                }
            }
        
        case "INFORMACION_CARGADA_NOVEDAD":
            return {
                ...state,
                listadoPersonal:action.payload?.listadoPersonal??[],
                mesActual:action.payload?.mesActual??new Date().getMonth() + 1,
                loadingInfo: false,
                novedad:true
            }
        
        case "OBTENER_INFORMACION_MODAL" :
            return {
                ...state,
                stateModalDetalle:{
                    informacion : {
                        detalle:[],
                        horarioLaboral:{
                            horaEntrada:"",
                            horaSalida:""
                        }
                    },
                    nombre:"",
                    loading:true,
                    month:action.payload.month,
                    year: action.payload.year,
                    idPersona :action.payload.idPersona,
                    identificacion: action.payload.identificacion,
                    consultaApiCalendario:action.payload.consultaApiCalendario
                }
            }
        
        case "INFORMACION_CARGADA_MODAL":
            return {
                ...state,
                stateModalDetalle:action.payload
            }
        
        case "CERRAR_MODAL":
            return {
                ...state,
                stateModalDetalle:{
                    informacion : {
                        detalle:[],
                        horarioLaboral:{
                            horaEntrada:"",
                            horaSalida:""
                        }
                    },
                    nombre:"",
                    loading:false,
                    month:action.payload.month,
                    year: action.payload.year,
                    idPersona :action.payload.idPersona,
                    identificacion:"",
                    consultaApiCalendario:false
                }
            }
        
        case "ACTUALIZAR_STATE_MODAL_SELECT":
            return {
                ...state,
                stateModalDetalle:action.payload
            }
            
        case "ACTUALIZAR_MES_CONSULTA":{
            return {
                ...state,
                mesActual:action.payload
            }
        }

        case "DESCARGAR_HOJA": {
            return {
                ...state,
                loadingHoja:true
            }
        }

        case "HOJA_DESCARGADA": {
            return {
                ...state,
                loadingHoja:false
            }
        }
        
        default:
            return state;

    }
};